import { format } from 'date-fns';

import getUserRole from 'utils/jwt/getUserRole';
import { ROLES } from 'config';
import checkAccess from '../../../utils/roles/checkAccess';
import getFranchiseRegion from '../../../utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/vendor-sales',
};

export const getColumns = () => [
  {
    id: 'date',
    label: 'Date',
    customValue: (val) => format(new Date(val.date), 'dd MMMM yyyy'),
    align: 'center',
    nameForSort: 'date',
  },
  { id: 'barcode', label: 'Barcode', align: 'center', nameForSort: 'barcode' },
  { id: 'orderNumber', label: 'Order Nr', align: 'center', nameForSort: 'order_number' },
  { id: 'product', label: 'Product', align: 'center', nameForSort: 'product_name' },
  { id: 'status', label: 'Status', align: 'center', nameForSort: 'status' },
  { id: 'price', label: 'Item Price', align: 'center', nameForSort: 'item_price' },
  { id: 'quantity', label: 'Qty', align: 'center', nameForSort: 'quantity' },
  { id: 'amount', label: 'Amount', align: 'center', disableSort: true },
];

export const getFilters = ({ dateRange, vendorId, options, region }) => {
  const role = getUserRole();

  const defaultArr = [
    {
      id: 'dateRange',
      variant: 'date',
      type: 'dateRange',
      value: dateRange.value,
      action: dateRange.change,
    },
  ];

  if (role === ROLES.YFC_ADMIN || role === ROLES.SUPER_ADMIN || role === ROLES.FRANCHISE_REGION_ADMIN) {
    return [
      ...defaultArr,
      {
        id: 'regions',
        type: 'select',
        label: 'Region',
        value: checkAccess([2]) ? getFranchiseRegion() : region.value,
        action: region.change,
        items: options?.regions?.length ? options.regions : [],
        disabledEdit: checkAccess([2]),
      },
      {
        id: 'vendor',
        type: 'select',
        label: 'Vendor',
        value: vendorId.value,
        action: vendorId.change,
        items: options?.vendors?.length ? [...options.vendors] : [],
        disabledEdit: checkAccess([2]) ? !getFranchiseRegion() : !region.value,
      },
    ];
  }

  return defaultArr;
};

export const getCardData = ({ totalSales, inSuspense, payable }) => [
  {
    id: 1,
    label: 'Total Sales',
    value: totalSales,
  },
  {
    id: 2,
    label: 'In Suspense',
    value: inSuspense,
  },
  {
    id: 3,
    label: 'Payable',
    value: payable,
  },
];
